/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-error-info': {
    width: 13,
    height: 13,
    viewBox: '0 0 13 13',
    data: '<defs><path pid="0" d="M2.345 5.987V7.55H.782V5.987h1.563zM.52.787l2.084.008-.528 4.16H1.05L.52.787z" id="svgicon-icon-error-info-a"/></defs><g transform="translate(.072 .133)" _fill="none" fill-rule="evenodd"><circle pid="1" _fill="#E25757" fill-rule="nonzero" cx="6" cy="6" r="6"/><g transform="translate(4.5 2)"><mask id="svgicon-icon-error-info-b" _fill="#fff"><use xlink:href="#svgicon-icon-error-info-a"/></mask><use _fill="#515151" xlink:href="#svgicon-icon-error-info-a"/><path pid="2" _fill="#FFF" mask="url(#svgicon-icon-error-info-b)" d="M0 0h3.126v8.337H0z"/></g></g>'
  }
})
